'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withBackgroundColor = exports.withTextColor = undefined;
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['color: ', ';'], ['color: ', ';']),
  _templateObject2 = (0, _taggedTemplateLiteral3.default)(['background-color: ', ';'], ['background-color: ', ';']),
  _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n        ', '\n        ', '\n    '], ['\n        ', '\n        ', '\n    ']);
var _styledComponents = require('styled-components');
var _themes = require('../themes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getThemeColor = function getThemeColor(colorName, theme) {
  var colors = theme.colors || _themes.DesignSystemTheme.colors;
  return colorName.split('.').reduce(function (obj, key) {
    return obj && obj[key];
  }, colors);
};
var withTextColor = exports.withTextColor = function withTextColor(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'dark' : _ref$color,
    theme = _ref.theme;
  return (0, _styledComponents.css)(_templateObject, getThemeColor(color, theme));
};
var withBackgroundColor = exports.withBackgroundColor = function withBackgroundColor(_ref2) {
  var _ref2$backgroundColor = _ref2.backgroundColor,
    backgroundColor = _ref2$backgroundColor === undefined ? 'clear' : _ref2$backgroundColor,
    theme = _ref2.theme;
  return (0, _styledComponents.css)(_templateObject2, getThemeColor(backgroundColor, theme));
};
exports.default = function () {
  return (0, _styledComponents.css)(_templateObject3, withTextColor, withBackgroundColor);
};